<template>
  <v-dialog
    :value="enableDialog"
    persistent
    scrollable
    :width="showRecyclingFields ? 2000 : 1400"
    @keydown.esc="closeButtonClickEvent"
  >
    <validation-observer
      ref="disposalReportValidator"
    >
      <v-card flat>
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title>
            処分終了報告（個別登録）
            <!-- <template v-if="showRecyclingFields">
              <span class="yellow--text ml-5" style="font-size: 70%">●</span>&nbsp;<span style="font-size: 70%">数量取得不可</span>
            </template> -->
          </v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text
          v-if="manifests"
          style="max-height: 70vh;overflow-y: scroll"
          class="mt-0 pt-0 px-0"
        >
          <v-card
            v-for="(manifest, index) in manifests"
            :class="{ 'excluded-manifest': !manifest.target_for_registration }"
            :key="manifest.id"
            flat
          >
            <v-card-text class="px-2">
              <v-row dense>
                <!-- マニフェスト情報 -->
                <v-col
                  cols="12"
                  :md="showRecyclingFields ? 3 : 4"
                >
                  <manifest
                    caller-type="disposal_report"
                    :manifest.sync="manifests[index]"
                    @targetOfRegistrationChange="targetOfRegistrationChangeCallback"
                  />
                </v-col>
                <!-- /マニフェスト情報 -->

                <!-- 基本情報 -->
                <v-col
                  cols="12"
                  :md="showRecyclingFields ? 4 : 5"
                >
                  <disposal-basic
                    :is-first-field="index === 0 && manifests.length > 1"
                    :manifest.sync="manifests[index]"
                    :quantity-units="quantityUnits"
                    :users="users"
                    @copyField="copyTarget"
                    @copyAllField="copyAllField"
                  />
                </v-col>
                <!-- /基本情報 -->

                <!-- 数量情報 -->
                <v-col
                  cols="12"
                  :md="showRecyclingFields ? 2 : 3"
                >
                  <disposal-quantity
                    :is-first-field="index === 0 && manifests.length > 1"
                    :manifest.sync="manifests[index]"
                    :quantity-units="quantityUnits"
                    :drivers="drivers"
                    :vehicles="vehicles"
                    @copyField="copyTarget"
                  />
                </v-col>
                <!-- /数量情報 -->

                <!-- 処分場処理情報等 -->
                <v-col
                  v-if="showRecyclingFields"
                  cols="12"
                  md="3"
                >
                  <disposal-recycling
                    :manifest.sync="manifests[index]"
                    :is-first-field="index === 0 && manifests.length > 1"
                    :quantity-units="quantityUnits"
                    caller-type="disposal_report"
                    @copyField="copyTarget"
                  />
                </v-col>
                <!-- /処分場処理情報等 -->
              </v-row>



            </v-card-text>
            <v-divider v-if="manifests.length > 1" />
          </v-card>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            :disabled="manifests===null"
            class="primary"
            @click="registerButtonClickEvent"
          >
            登録
          </v-btn>
        </v-card-actions>

      </v-card>
    </validation-observer>
    <Confirm ref="confirm" />
    <data-table-modal
      :descriptions="['自動連携されないマニフェストがあります。', '対象の１次マニフェストは手動で最終処分終了報告を登録してください。']"
      :enable="enablePrimaryManifestModal"
      :headers="primaryManifestHeaders"
      :items="primaryManifestResult"
      positive
      positive-caption="継続して登録"
      @close="dialogCloseCallback"
      @positiveCallback="dialogRegisterCallback"
    />
    <data-table-modal
      :enable="enableFirstManifestRecycleModal"
      :headers="firstManifestRecycleTableHeader"
      :items="firstManifestRecycleResult"
      descriptions="紐付く1次マニフェストの中間処分報告が再資源設定されている為、登録出来ません。"
      @close="dialogCloseCallback"
    />

  </v-dialog>

</template>

<script>
import {mapActions} from "vuex";
import Manifest from './contents/_Manifest.vue'
import DisposalBasic from './contents/_DisposalBasic.vue'
import DisposalQuantity from './contents/_DisposalQuantity.vue'
import DisposalRecycling from './contents/_DisposalRecycling.vue'
import Confirm from '@/components/Confirm.vue'
import DataTableModal from "@/driver/pages/dialogs/_DataTableModal.vue";

export default {
  name: "DisposalReportDialog",
  components: {
    DataTableModal,
    Manifest,
    DisposalBasic,
    DisposalQuantity,
    DisposalRecycling,
    Confirm,
  },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    manifestIds: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: () => null,
    },
    sortType: {
      type: String,
      default: () => null,
    },
    showRecyclingFields: {
      type: Boolean,
      default: () => false,
    },
    orderIds: {
      type: Array,
      default: () => [],
    },
    targetManifestIds: {
      type: Array,
      default: () => [],
    },
    /**
     * マニフェスト(1次, 2次)
     */
    manifestLevel: {
      type: String,
      default: "first_manifest"
    },
  },
  data() {
    return {
      manifests: [],
      users: [],
      drivers: [],
      vehicles: [],
      quantityUnits: [],

      enablePrimaryManifestModal: false,
      primaryManifestHeaders: [
        { value: 'second_manifest_no', text: '2次マニフェスト番号' },
        { value: 'second_manifest_id', text: 'DXEマニ番号' },
        { value: 'primary_manifest_no', text: '1次マニフェスト番号' },
        { value: 'primary_manifest_id', text: 'DXEマニ番号' },
        { value: 'primary_manifest_type_name', text: 'マニフェスト区分' },
        { value: 'primary_manifest_collected_date', text: '引渡日' },
      ],
      primaryManifestResult: [],

      enableFirstManifestRecycleModal: false,
      firstManifestRecycleTableHeader: [
        { value: "manifest_no",
          text: "2次マニフェスト番号",
          width: "50%"
        },
        { value: "id",
          text: "DXEマニ番号",
          width: "50%"
        },
      ],
      firstManifestRecycleResult: []

    }
  },
  computed: {},
  watch: {
    enableDialog (newValue) {
      this.$nextTick(() => this.$refs.disposalReportValidator.reset())
      this.manifests = null
      if (newValue) {
        this.setVariable()
      }
    },
  },
  created() {
  },
  methods: {
    ...mapActions('DriverManifestDisposalReport', {
      fetchDisposalReports: 'show',
      updateDisposalReports: 'update',
    }),
    ...mapActions('DriverOrderDisposalReport', {
      fetchDisposalReportsByOrder: 'show',
      updateDisposalReportsByOrder: 'update',
    }),
    ...mapActions('DriverMasterSearchUser', {
      fetchUsers: 'index',
    }),
    ...mapActions('DriverMasterSearchDriver', {
      fetchDrivers: 'only_text',
    }),
    ...mapActions('DriverMasterSearchVehicle', {
      fetchVehicles: 'search'
    }),
    ...mapActions('DriverMasterSearchQuantityUnit', {
      fetchQuantityUnits: 'index',
    }),
    ...mapActions('DriverMasterRecycleDisposerDisposalMethod', {
      fetchRecycleDisposerDisposalMethodEdit: 'edit',
    }),
    /**
     * 紐付く1次マニの自動連携チェック処理
     */
    ...mapActions("DriverManifestPrimaryManifestSyncCheck", {
      cheCheck: "create"
    }),

    ...mapActions("DriverManifestFirstManifestIncludedRecycleCheck", {
      firstManifestIncludedRecycleCheck: "create"
    }),

    closeButtonClickEvent () {
      this.$emit('cancelCallback')
    },
    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      const $self = this;
      this.$refs.disposalReportValidator.validate().then((result) => {
        if (result) {
          if (this.manifestLevel === 'first_manifest') {
            setTimeout($self.registerInformation, 500);
          } else if (this.manifestLevel === 'second_manifest') {
            // if (this.showRecyclingFields) {
            //   this.checkAndRegisterSecondManifest();
            // } else {
              this.firstManifestIncludedRecycleCheckAndRegisterSecondManifest()
            // }
          }
        }
      })
    },
    registerInformation () {
      let params = this.buildParams()

      if (params.manifests.length === 0) {
        return
      }

      if (this.type === "Managements") {
        this.updateDisposalReports({params: params}).then(() => {
          this.$emit('registerEvent')
        })
      } else {
        params['order_ids'] = this.orderIds
        this.updateDisposalReportsByOrder({params: params}).then(() => {
          this.$emit('registerEvent')
        })
      }
    },
    /**
     * 基本情報
     * 登録対象チェックボックス変更 コールバック
     *
     * 同一オーダーIDを持つオブジェクトを検索し存在する場合は更新する.
     * @param order_id
     * @param checkable
     */
    targetOfRegistrationChangeCallback(order_id, checkable) {
      for (const manifest of this.manifests) {
        if (manifest.order_id === order_id) {
          manifest.target_for_registration = checkable;
        }
      }
    },

    /**
     * 紐付く1次の再資源化チェック
     * 2次が通常 且つ 最終で、紐付く1次に再資源が含まれる場合エラーとする.
     */
    firstManifestIncludedRecycleCheckAndRegisterSecondManifest() {
      /*
       * 対象として選択されているマニフェストで、
       * 処分終了報告_区分が「最終」で、処分場処理方法が選択されていないマニフェストを抽出
       */
      const targetManifests = this.manifests.filter(manifest =>
        manifest.target_for_registration &&
        manifest.disposal_report_type === 'last_report' &&
        (manifest.after_disposal_details === undefined || manifest.after_disposal_details.length <= 0)
      );

      const targetManifestIds = targetManifests.map(manifest => manifest.id)

      this.firstManifestRecycleResult = [];

      if (targetManifestIds.length > 0) {
        // 最終・再資源なしが含まれる
        const params = { manifest_ids: targetManifestIds }
        this.firstManifestIncludedRecycleCheck({ params: params }).then((data) => {
          const result = data.result
          const content = data.content;
          if (result.code === 'ok') {
            this.checkAndRegisterSecondManifest()
          } else {
            console.log('NGNG', content)
            this.firstManifestRecycleResult = content.invalid_manifests;
            this.enableFirstManifestRecycleModal = true;
          }
        })
      } else {
        // 以外(全て中間 or 最終・再資源ありのみ
        this.checkAndRegisterSecondManifest()
      }
    },

    /**
     * 2次マニ
     * 登録前の1次マニへの自動連携チェック処理
     */
    checkAndRegisterSecondManifest () {
      const $self = this;

      console.log(this.manifests)

      // チェック付きで、最終処分だけを抽出
      const targetManifests = this.manifests.filter(manifest =>
        manifest.target_for_registration &&
        manifest.disposal_report_type === 'last_report' &&
        (manifest.after_disposal_details && manifest.after_disposal_details.length > 0)
      );

      const targetManifestIds = targetManifests.map(manifest => manifest.id)

      this.primaryManifestResult = [];
      this.cheCheck({ params: { manifest_ids: targetManifestIds }}).then((response) => {
        const result = response.result;
        const content = response.content;
        if (result.code === 'ok') {
          setTimeout($self.registerInformation, 500);
        } else {
          this.primaryManifestResult = content.unsync_primary_manifests
          this.enablePrimaryManifestModal = true;
        }
      })

    },
    /**
     * 連携対象外マニフェストのダイアログ 閉じるボタンコールバック
     */
    dialogCloseCallback() {
      this.enablePrimaryManifestModal = false;
      this.enableFirstManifestRecycleModal = false;
    },
    /**
     * 連携対象外マニフェストのダイアログ 実行ボタンコールバック
     */
    dialogRegisterCallback() {
      this.dialogCloseCallback();
      const $self = this;
      setTimeout($self.registerInformation, 500);
    },
    buildParams () {
      const params = []

      // チェック付きだけを抽出
      const targetManifests = this.manifests.filter(manifest => manifest.target_for_registration);

      targetManifests.forEach((manifest, _) => {
        let param = {}
        param.id = manifest.id
        param.disposal_report_type = manifest.disposal_report_type
        param.disposal_report_person = manifest.disposal_report_person
        param.disposal_report_end_date = manifest.disposal_report_end_date
        param.disposal_report_reporter = manifest.disposal_report_reporter
        param.disposal_report_driver = manifest.disposal_report_driver
        if (manifest.disposal_report_vehicle_number === null) {
          param.disposal_report_vehicle_number = ''
        } else if (typeof manifest.disposal_report_vehicle_number === "object") {
          param.disposal_report_vehicle_number = manifest.disposal_report_vehicle_number.number
        } else {
          param.disposal_report_vehicle_number = manifest.disposal_report_vehicle_number
        }
        param.disposal_report_receipt_date = manifest.disposal_report_receipt_date
        param.disposal_report_amount = manifest.disposal_report_amount
        param.disposal_report_amount_unit_id = manifest.disposal_report_amount_unit_id
        param.disposal_report_remarks = manifest.disposal_report_remarks

        // 基準重量
        param.disposal_standard_quantity_type = manifest.disposal_standard_quantity_type
        // 重量(kg)
        param.disposal_quantity = (Number(manifest.disposal_quantity) === 0 || isNaN(Number(manifest.disposal_quantity))) ? null : manifest.disposal_quantity
        // 再資源化処分場処理方法ID(処分場処理方法)
        param.recycle_disposer_disposal_method_id = manifest.recycle_disposer_disposal_method_id

        const afterDisposalDetails = Array.isArray(manifest.after_disposal_details)
          ? manifest.after_disposal_details
          : []

        param.after_disposal_details = afterDisposalDetails.map((detail) => {
          return {
            // 再資源化処分場処理方法詳細ID
            recycle_disposer_disposal_method_detail_id: detail.id || null,
            // 処分前重量(kg)
            before_disposal_method_kg: detail.before_disposal_method_kg || null,
            // 処分割合
            before_disposal_ratio: detail.before_disposal_ratio || null,
            // 処理後重量(kg)
            after_disposal_item_kg: detail.after_disposal_item_kg || null,
            // 処理後割合
            after_disposal_ratio: detail.after_disposal_ratio || null,
            // 備考
            comment: detail.comment || null,
            // 最終処分終了報告フラグ
            final_disposal: detail.final_disposal || false,
          }
        })

        params.push(param)
      })

      return {
        manifests: params,
        type: this.type,
      }
    },
    setVariable () {
      this.fetchDrivers({without_invisible: true}).then((content) => { this.drivers = content })
      this.fetchQuantityUnits().then((content) => { this.quantityUnits = content.quantity_units })
      this.fetchUsers({without_invisible: true}).then((content) => { this.users = content.users })
      this.fetchVehicles({registered_number: ''}).then((content) => { this.vehicles = content.vehicles })

      let params = { manifest_ids: this.manifestIds, sort_type: this.sortType }
      if (this.type === "Managements") {
        this.fetchDisposalReports({ params: params }).then((content) => {
          this.manifests = content.manifests
        })
      } else {
        /** 受注発注の場合はorder単位でのマニフェスト絞込が必要 */
        params["order_ids"] = this.orderIds
        this.fetchDisposalReportsByOrder({ params: params }).then((content) => {
          this.manifests = content.manifests
        })
      }
    },
    copyTarget (column, value) {
      if (this.isBlank(value)) {
        return;
      }

      // 処分場処理方法（再資源化）の複写時は、条件が一致しないマニフェストがあるかチェック
      if (column === 'recycle_disposer_disposal_method_id') {
        this.copyRecycleDisposerDisposalMethod(value);
        return;
      }

      for (let i = 0; i < this.manifests.length; i++) {
        const manifest = this.manifests[i];
        if (column === 'disposal_report_type') {
          /* 報告区分 */
          manifest.disposal_report_type = value
        } else if (column === 'disposal_report_person') {
          /* 処分担当者 */
          manifest.disposal_report_person = value
        } else if (column === 'disposal_report_end_date') {
          /* 処分終了日 */
          manifest.disposal_report_end_date = value
        } else if (column === 'disposal_report_reporter') {
          /* 報告担当者 */
          manifest.disposal_report_reporter = value
        } else if (column === 'disposal_report_driver') {
          manifest.disposal_report_driver = value
        } else if (column === 'disposal_report_vehicle_number') {
          manifest.disposal_report_vehicle_number = value
        } else if (column === 'disposal_report_receipt_date') {
          manifest.disposal_report_receipt_date = value
        } else if (column === 'disposal_report_amount') {
          manifest.disposal_report_amount = value
        } else if (column === 'disposal_report_amount_unit_id') {
          manifest.disposal_report_amount_unit_id = value
        } else if (column === 'disposal_report_remarks') {
          manifest.disposal_report_remarks = value
        } else if (column === 'disposal_standard_quantity_type') {
          this.$set(manifest, 'disposal_standard_quantity_type', value)
        } else if (column === 'disposal_quantity') {
          this.$set(manifest, 'disposal_quantity', value)
        }
      }
    },
    /**
     * 処分場処理方法（再資源化）を複写する
     * 複写できないマニフェストが存在する場合は確認メッセージを表示
     */
    copyRecycleDisposerDisposalMethod (value) {
      if (!value || this.manifests.length === 0) {
        return;
      }

      // 複写元（最初のマニフェスト）の条件を取得
      const sourceManifest = this.manifests[0];

      // 処分場処理方法の詳細情報を取得（item_idsを含む）
      this.fetchRecycleDisposerDisposalMethodEdit({ id: value }).then((recycleDisposerDisposalMethod) => {
        const sourceConditions = {
          disposer_id: sourceManifest.disposer_id,
          disposer_location_code: sourceManifest.disposer_location_code,
          item_ids: recycleDisposerDisposalMethod.item_ids || [],
        };

        // 複写先のマニフェストを条件でフィルタリング
        const copyableManifests = [];
        const nonCopyableManifests = [];

        for (let i = 1; i < this.manifests.length; i++) {
          const targetManifest = this.manifests[i];

          // 基本条件（処分先ID、処分場所コード）が一致するかチェック
          let isMatch =
            targetManifest.disposer_id === sourceConditions.disposer_id &&
            targetManifest.disposer_location_code === sourceConditions.disposer_location_code;

          // 処分場処理方法に取扱品目が設定されている場合、複写先のitem_idがitem_idsに含まれるかチェック
          if (isMatch && sourceConditions.item_ids.length > 0) {
            isMatch = sourceConditions.item_ids.includes(targetManifest.item_id);
          }

          if (isMatch) {
            copyableManifests.push(targetManifest);
          } else {
            nonCopyableManifests.push(targetManifest);
          }
        }

        // 複写できないマニフェストが存在する場合は確認メッセージを表示
        if (nonCopyableManifests.length > 0) {
          this.$refs.confirm.open({
            title: '確認',
            message: '複写できないマニフェストが存在します。複写しますか？',
            options: { width: 400 }
          }).then((confirmed) => {
            if (confirmed) {
              // 複写可能なマニフェストにのみ処分場処理方法を設定
              for (const manifest of copyableManifests) {
                this.$set(manifest, 'recycle_disposer_disposal_method_id', value);
              }
            }
          });
        } else {
          // 複写可能なマニフェストにのみ処分場処理方法を設定
          for (const manifest of copyableManifests) {
            this.$set(manifest, 'recycle_disposer_disposal_method_id', value);
          }
        }
      }).catch((error) => {
        console.error('処分場処理方法の取得に失敗しました:', error);
      });
    },
    copyAllField (value) {
      for (const manifest of this.manifests) {
        // 報告区分
        if (value.disposal_report_type !== null && value.disposal_report_type !== "") {
          manifest.disposal_report_type = value.disposal_report_type
        }
        // 処分担当者
        if (value.disposal_report_person !== null && value.disposal_report_person !== "") {
          manifest.disposal_report_person = value.disposal_report_person
        }
        // 処分終了日
        if (value.disposal_report_end_date !== null && value.disposal_report_end_date !== "") {
          manifest.disposal_report_end_date = value.disposal_report_end_date
        }
        // 報告担当者
        if (value.disposal_report_reporter !== null && value.disposal_report_reporter !== "") {
          manifest.disposal_report_reporter = value.disposal_report_reporter
        }
        // 廃棄物受領日
        if (value.disposal_report_receipt_date !== null && value.disposal_report_receipt_date !== "") {
          manifest.disposal_report_receipt_date = value.disposal_report_receipt_date
        }
        // 処分備考
        if (value.disposal_report_remarks !== null && value.disposal_report_remarks !== "") {
          manifest.disposal_report_remarks = value.disposal_report_remarks
        }
      }
    },
  },
}
</script>
<style scoped lang="scss">
.excluded-manifest {
  background-color: #E0E0E0 !important;;
}
</style>
